import { Link } from "react-router-dom";

const NAV_GROUPS = [
  {
    title: "影视导航",
    links: [
      { label: "首页", to: "/" },
      { label: "电影", to: "/movies" },
      { label: "电视剧", to: "/tvshows" },
      { label: "影视资讯", to: "/news" },
    ],
  },
  {
    title: "发现更多",
    links: [
      { label: "搜索影视", to: "/search" },
      { label: "我的收藏", to: "/favorites" },
    ],
  },
];

const SOCIALS = [
  { icon: "ri-weibo-fill", label: "微博", href: "#" },
  { icon: "ri-wechat-fill", label: "微信", href: "#" },
  { icon: "ri-qq-fill", label: "QQ", href: "#" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩", href: "#" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-background-200/70 bg-secondary-50">
      <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-accent-500 to-primary-600" />
      <div className="w-full px-4 py-12 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-moon-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                夜无疆影视大全
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
              夜无疆专注为影视爱好者提供电影、电视剧的内容介绍与影视资讯推荐。在这里，你可以按类型、地区与年份快速浏览作品，了解剧情简介与演职人员，并随时获取最新的影视动态。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-foreground-600 transition-colors duration-200 hover:border-primary-500/60 hover:text-primary-400"
                >
                  <i className={`${social.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {NAV_GROUPS.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-semibold text-foreground-900">{group.title}</h3>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors duration-200 hover:text-primary-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-background-300/60 pt-6">
          <p className="text-xs leading-6 text-foreground-500">
            © 2026 夜无疆影视大全 · 本站为影视内容展示与资讯推荐平台，不提供在线播放与下载服务。收藏功能仅保存在本地浏览器，用于功能演示。
          </p>
        </div>
      </div>
    </footer>
  );
}